import { cn } from '@/lib/shadcn/lib/utils';

export function Profile({ className }: { className?: string }) {
  return (
    <svg
      className={cn('size-full', className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="6" r="4" fill="#199A94" />
      <ellipse opacity="0.5" cx="12" cy="17" rx="7" ry="4" fill="#199A94" />
    </svg>
  );
}
